export const transparencia_item = [
    {
        "transparencia_item_nombre" : "Ir a Plataforma Nacional de Transparencia",
        "transparencia_item_url" : "https://consultapublicamx.plataformadetransparencia.org.mx/vut-web/faces/view/consultaPublica.xhtml#inicios"
    },
    {
        "transparencia_item_nombre" : "Art. 69 ley de Transparencia (48 Rubros)",
        "transparencia_item_url" : "Rubros"
    },
        {
        "transparencia_item_nombre" : "MIR",
        "transparencia_item_url" : "MIR"
    },
    {
        "transparencia_item_nombre" : "Programa Anual de Adquisiciones",
        "transparencia_item_url" : "PAAS"
    },
    {
        "transparencia_item_nombre" : "Calendarios Autorizados",
        "transparencia_item_url" : "CalendariosAutorizados"
    }
]